import * as React from 'react';

import cn from 'classnames';

import { EElementPosition } from '@enums';

import { Icon } from '@common/components/Icon';

import { IconError } from '@icons';

import { Label } from '../Label';

import { IInputGroupProps } from './types';

import * as s from '../Input.scss';

export class InputGroup extends React.Component<IInputGroupProps> {

	static defaultProps: IInputGroupProps = {
		descriptionPosition: EElementPosition.BOTTOM,
		withErrorIcon: false,
	};

	render() {
		const {
			className,
			description,
			descriptionPosition,
			error,
			id,
			isValid,
			label,
			rightElement,
			withErrorIcon,
		} = this.props;

		const isVisible = {
			topDescription: !!description && descriptionPosition === EElementPosition.TOP,
			bottomDescription: !!description && descriptionPosition === EElementPosition.BOTTOM,
			rightElement: !!rightElement,
			errorIcon: isValid === false && withErrorIcon,
			error: !!error,
		};

		return (
			<div className={cn(s.container, className)}>
				<Label
					className={cn({
						[s.invalidLabel]: !isValid,
					})}
					text={label}
					id={id}
				/>

				{isVisible.topDescription &&
					<div className={cn(s.descriptionTopCaption, !!label && s.descriptionTopCaptionWithLabel)}>
						<span>{description}</span>
					</div>
				}

				<div className={s.inputContainer}>
					{this.props.children}
					{isVisible.rightElement && <div className={s.rightElement}>{rightElement}</div>}
					{isVisible.errorIcon && <Icon glyph={IconError} className={s.invalidIcon} />}
				</div>

				{isVisible.bottomDescription &&
					<div className={s.descriptionBottomCaption}>
						<span>{description}</span>
					</div>
				}

				{isVisible.error &&
					<div className={s.errorCaption}>
						<span className={cn(s.error, s.caption)}>{error}</span>
					</div>
				}

			</div>
		);
	}

}
